import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import EventEHRImageAvatar from "../../Atoms/image-avatar/EventEHRImageAvatar";
import { destructStatusData } from "../../../utils/statusConstants";

interface ListItemsDataProps {
  title?: string;
  subTitle?: string;
  valueOfSubTitle?: string;
  imgURL?: string;
  name?: string;
  totalTask?: number;
  status?: string;
}

interface EventEHRItemListCardProps {
  cardTitle: string;
  listItemsData?: ListItemsDataProps[];
  itemsActionButtonName?: string;
  view?: string;
  actionViewAll?: boolean;
  noDataDataFoundMessage?: string;
  showStatus?: boolean;
  getStatusDotColor?: (status: string) => string;
  getStatusBackground?: (status: string) => string;
  getStatusTextColor?: (status: string) => string;

  handleItemsABClick?: (data: any) => void;
  handleViewAllClick?: () => void;
}

export default function EventEHRItemListCard({
  cardTitle = "Card Title Here...",
  listItemsData,
  itemsActionButtonName = "Name",
  view,
  actionViewAll,
  noDataDataFoundMessage,
  showStatus = false,
  getStatusDotColor = (status) => "",
  getStatusBackground = (status) => "",
  getStatusTextColor = (status) => "",
  handleItemsABClick,
  handleViewAllClick,
}: EventEHRItemListCardProps) {
  return (
    <div className="border-1px-solid-D2D2D2 rounded w-full">
      <div className="flex justify-between items-center m-3">
        <div className="text-sm	font-semibold	 text-[#565656]">{cardTitle}</div>
        {listItemsData?.length ? (
          <div
            className="text-xs font-medium text-[#044677] cursor-pointer"
            onClick={() => {
              handleViewAllClick && handleViewAllClick();
            }}
          >
            {actionViewAll ? "View all" : ""}
          </div>
        ) : (
          ""
        )}
      </div>
      <List sx={{ width: "100%", padding: "0 12px" }}>
        {listItemsData?.map((data, index: any) => (
          <div key={index}>
            <ListItem
              sx={{
                // padding: view === "withoutImage" ? "9px 0" : "2px 0",
                padding: "9px 0",
              }}
            >
              {!(view === "withoutImage") && (
                <EventEHRImageAvatar
                  labelText={data?.title}
                  image={data?.imgURL}
                  commonStyle={{
                    width: "36px",
                    height: "35px",
                    marginRight: "12px",
                    marginBottom: "3px",
                    objectFit: "cover",
                    border: "1px solid #BCBCBC",
                    borderRadius: "50%",
                  }}
                  customTextStyle={{
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                />
              )}
              <ListItemText
                primary={
                  <div className="text-sm font-medium text-[#1D1D1D] inline">
                    {data?.title}
                  </div>
                }
                secondary={
                  <React.Fragment>
                    <div className="text-[10px] font-normal text-[#979797] inline">
                      {data?.subTitle}
                    </div>
                    <div className="text-[10px] font-normal text-[#979797] inline">
                      {data?.valueOfSubTitle}
                    </div>
                  </React.Fragment>
                }
                sx={{
                  marginTop: 0, // Remove default margin
                  marginBottom: 0, // Remove default margin
                }}
              />
              {showStatus ? (
                // Status-related rendering
                <div
                  className="flex items-center mr-3"
                  style={{
                    backgroundColor: getStatusBackground(data?.status || ""),
                    color: getStatusTextColor(data?.status || ""),
                    padding: "4px 8px",
                    borderRadius: "16px",
                  }}
                >
                  <span
                    className="w-2 h-2 mr-1"
                    style={{
                      background: getStatusDotColor(data?.status || ""),
                      borderRadius: "50%",
                    }}
                  ></span>
                  {/* <img
                    src={getStatusDotColor(data?.status || "")}
                    alt="status-dot"
                    className="w-2 h-2 mr-1"
                  /> */}
                  <span className="text-xs font-medium">
                    {destructStatusData(data?.status)}
                  </span>
                </div>
              ) : (
                // Action button rendering
                <div
                  className="text-[#005596] text-xs font-medium cursor-pointer mr-3"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() => {
                    handleItemsABClick && handleItemsABClick(data);
                  }}
                >
                  {itemsActionButtonName}
                </div>
              )}
            </ListItem>
            {index !== listItemsData.length - 1 && (
              <Divider variant="fullWidth" component="li" />
            )}
          </div>
        ))}
        {listItemsData?.length === 0 && (
          <div className="flex justify-center items-center font-medium h-[233px] pb-[36px] text-[#7f7f7f]">
            {noDataDataFoundMessage}
          </div>
        )}
      </List>
    </div>
  );
}
